import React, { useState, useEffect } from 'react'
import { Pagination, Select, Button, Spin, message, AutoComplete, Input, Icon } from 'antd'
import { getListLazeError, exportListLazeError } from '../../../services/api/3dApi'
import LazeCuttingErrorTable from './LazeCuttingErrorTable'
import { Link } from 'react-router-dom'
import FilterDateRangeV2 from '../../shared/FilterDateRangeV2'
import FilterProductType from '../../batchesV3/components/filters/FilterProductType'
import SearchField from '../../home/components/filters/SearchField'
import UseDebounce from '../../users/helpers/UseDebounce'
import {createJobExport} from '../../../helpers/createJobExport'
import downloadFileFromData from '../../../helpers/downloadFileFromData'
import moment from 'moment'

function LazeCuttingErrorPage() {
    const [listLaze, setListLaze] = useState([])
    const [error, setError] = useState('')
    const [total, setTotal] = useState(0)
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(50)
    const [batchName, setBatchName] = useState('')
    const [listUser, setListUser] = useState([])
    const [user, setUser] = useState([])
    const [type, setType] = useState([])
    const [errorType, setErrorType] = useState('')
    const [errorAt, setErrorAt] = useState({})
    const [loading, setLoading] = useState(false)

    const debounceBatchName = batchName === '' ? UseDebounce(batchName, 0) : UseDebounce(batchName, 500)
    const debounceError = errorType === '' ? UseDebounce(errorType, 0) : UseDebounce(errorType, 500)

    const options = [
        'Cắt hỏng',
        'Cắt thiếu',
    ]

    const fetchListLaze = async () => {
        setLoading(true)
        try {
            const payload = {
                page: page,
                limit: limit,
            }
            if (batchName) payload.batch_name = batchName
            if (!!user && !!user.length) payload.user_mark = user
            if (!!type && !!type.length) payload.type = type
            if (!!errorType) payload.error_info = errorType
            if (Object.keys(errorAt).length && !!errorAt.from && !!errorAt.to) {
                payload.mark_error_at = errorAt
            }

            const { data: res } = await getListLazeError(payload)
            const { data, success, message: mess } = { ...res }
            if (success) {
                setListLaze(data.itemsMarkError)
                setTotal(data.total)
                setPage(data.page)
                setLimit(data.limit)
                setListUser(data.users)
            } else {
                setError(mess)
                message.error(mess)
            }
        } catch (error) {
            setError(error.message)
            message.error(error.message)
        }
        finally {
            setLoading(false)
        }
    }

    const handleBatchName = (field, value) => {
        setBatchName(value)
        setPage(1)
    }

    const handleChangeUser = (value) => {
        setUser(value)
        setPage(1)
    }

    const handleChangeType = (value) => {
        setType(value)
        setPage(1)
    }
    const handleChangeErrorAt = (field, value) => {
        setErrorAt(value)
        setPage(1)
    }
    const handleChangeErrorType = (value) => {
        setErrorType(value)
        setPage(1)
    }
    const exportListLaze = async () => {
        setLoading(true)
        setError('')

        try {
            const payload = {
                page: page,
                limit: limit,
            }
            if (batchName) payload.batch_name = batchName
            if (!!user && !!user.length) payload.user_mark = user
            if (!!type && !!type.length) payload.type = type
            if (!!errorType) payload.error_info = errorType
            if (Object.keys(errorAt).length && !!errorAt.from && !!errorAt.to) {
                payload.mark_error_at = errorAt
            }

            const { data: res } = await exportListLazeError(payload)
            if(typeof res !== 'string'){
                const { success, message: mess, data } = res
                if(!success) throw new Error(mess)
            
                if (Object.keys(data).length > 0) {
                    createJobExport(data)
                }
            }else {
                if (res) downloadFileFromData(res, { filename: `Laze-error-items-${moment().format('YYYY-MM-DD-HH-mm-ss')}.csv` })
            }

        } catch (e) {
            setError(e.message)
            setLoading(false)
        }finally{
            setLoading(false)
        }
    }

    const handlePageChange = (current) => {
        setPage(current)
    }

    const handleShowSizeChange = (current, size) => {
        setPage(1)
        setLimit(size)
    }

    useEffect(() => {
        fetchListLaze()
    }, [debounceBatchName, debounceError, user, type, errorAt, limit, page])

    const { Option } = Select

    return (
        <div className='LazeCuttingErrorPage'>
            <div className='container-fluid min-vh-100'>
                <div className='col-12 mx-auto bg-white shadow-sm py-3'>
                    <div className='mb-3 d-flex justify-content-between mt-3'>
                        <h3 className='mb-0'>Danh sách item cắt lỗi</h3>
                        <div className='d-flex align-items-center'>
                            <Button
                                className='ant-btn ant-btn-primary ml-3'
                                onClick={exportListLaze}
                                disabled={loading}
                            >
                                Export
                            </Button>
                            <Link
                                className='ant-btn ml-3'
                                to='/laze-cutting'
                                disabled={loading}
                            >
                                Đánh dấu cắt lỗi
                            </Link>
                        </div>
                    </div>
                    <div className='jumbotron p-3 mb-3'>
                        <div className='row align-items-start'>
                            <div className='col-12 col-xl-2'>
                                <label className="d-block w-100 font-weight-bold mb-1">Tên lô</label>
                                <SearchField
                                    field='name'
                                    placeholder='Tìm kiếm theo tên Lô...'
                                    onChangeInput={handleBatchName}
                                    disabled={loading}
                                />
                            </div>
                            <div className='col-12 col-xl-2'>
                                <label className="font-weight-bold mb-1">Ngày đánh dấu lỗi</label>
                                <FilterDateRangeV2
                                    field='packaged_at'
                                    onDatesChange={handleChangeErrorAt}
                                    showTime={true}
                                    disabled={loading}
                                />
                            </div>
                            <div className='col-12 col-xl-3'>
                                <label className='font-weight-bold mb-1'>Loại sản phẩm</label>
                                <FilterProductType
                                    productTypes={type}
                                    onChangeProductType={handleChangeType}
                                    disabled={loading}
                                />
                            </div>
                            <div className='col-12 col-xl-2'>
                                <label htmlFor="error_type" className="Error font-weight-bold mb-1">Lý do lỗi:</label>
                                <AutoComplete
                                    options={options}
                                    dataSource={options}
                                    filterOption={(inputValue, option) =>
                                        option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                    }
                                    onChange={handleChangeErrorType}
                                    allowClear
                                    placeholder="Search lý do lỗi"
                                    className='w-100'
                                    disabled={loading}
                                >
                                    <Input suffix={<Icon type="search" className="certain-category-icon" />} />
                                </AutoComplete>
                            </div>

                            <div className='col-12 col-xl-3'>
                                <div className="FilterSelect">
                                    <div className='font-weight-bold mb-1'>Người đánh dấu lỗi</div>
                                    <Spin spinning={loading}>
                                        <Select
                                            mode="multiple"
                                            style={{ width: '100%' }}
                                            showArrow={true}
                                            placeholder="Vui lòng chọn người đánh dấu lỗi bạn muốn tìm kiếm"
                                            defaultValue={user}
                                            onChange={handleChangeUser}
                                            value={user || []}
                                            allowClear
                                        >
                                            {
                                                listUser.map((option, index) => {
                                                    return <Option key={index} value={option}>{option}</Option>
                                                })
                                            }
                                        </Select>
                                    </Spin>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mb-3 headPagination">
                        <div>
                            {error && <div className='text-danger'>{error}</div>}
                        </div>
                        <Pagination
                            current={page}
                            total={total}
                            pageSize={limit}
                            className='text-right' showSizeChanger
                            pageSizeOptions={['10', '20', '50', '100']}
                            showTotal={(sum, range) => sum > 0 &&
                                <div>
                                    {`Hiển thị ${range[0]} đến ${range[1]} của `}<strong>{`${total} items`}</strong>
                                </div>}
                            onChange={handlePageChange}
                            onShowSizeChange={handleShowSizeChange}
                            disabled={loading}
                        />
                    </div>
                    <Spin spinning={loading} tip='Loading...'>
                        <LazeCuttingErrorTable
                            listLaze={listLaze}
                            setType={setType}
                        />
                    </Spin>
                    <Pagination
                        current={page}
                        total={total}
                        pageSize={limit}
                        className='text-right'
                        showSizeChanger
                        showQuickJumper
                        pageSizeOptions={['10', '20', '50', '100']}
                        onChange={handlePageChange}
                        onShowSizeChange={handleShowSizeChange}
                        disabled={loading}
                    />
                </div>
            </div>
        </div>
    )
}

export default LazeCuttingErrorPage